var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadPunchIn = function SvgFadPunchIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.28 67.494a3.999 3.999 0 0 1 4.005-3.994H83.78c8.837 0 19.659 6.169 24.165 13.767l50.391 84.966c4.51 7.604 15.33 13.767 24.157 13.767H227.7a4.002 4.002 0 0 1 4.005 4.007v8.986a4.004 4.004 0 0 1-3.998 4.007h-58.708c-8.835 0-19.602-6.196-24.04-13.828L95.32 93.828C90.88 86.19 80.114 80 71.28 80h-43c-2.21 0-4-1.797-4-3.994v-8.512z",
    fillRule: "evenodd"
  })));
};
export { SvgFadPunchIn as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-punch-in.18cd4f5b.svg";